
import { useQuery } from 'react-query';
import { useContext } from 'react';
import { AuthContext } from '../Context/AuthContext';

const useRecentMessagesCount = () => {
  const { token } = useContext(AuthContext);

  const fetchRecentMessagesCount = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/publicmsgs/recent-messages`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        throw new Error('Failed to fetch data');
      }
 

      const data = await response.json();
      return data.recentMessages;
    } catch (error) {
      throw new Error('Failed to fetch data');
    }
  };

  const { data: recentMessage, isLoading, isError } = useQuery('recentMessageCount', fetchRecentMessagesCount);

  return { recentMessage, loading: isLoading, error: isError };
};

export default useRecentMessagesCount;